(async () => {

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('main-nav', class extends baseComponent.default {
        elements = {
            dropdowns: '*[data-dropdown]'
        };

        modalInit = false;

        render() {
            this.$dropdowns.filter(drop => drop.hasAttribute('data-offset-drop')).map(dropdown => {
                const clientRect = dropdown.getBoundingClientRect();
                if (document.documentElement.clientWidth - clientRect.x + clientRect.width < 600) {
                    dropdown.classList.add('@drop-reverse');
                }
            })

          var meganavAccordionLinks = this.querySelectorAll('.meganav-item-accordion-link');
          if (meganavAccordionLinks.length) {
            meganavAccordionLinks.forEach(function (item) {
              item.addEventListener('click', function(e) {
                e.preventDefault();
                this.classList.toggle('active');
                var accordionBody = this.closest('.meganav-item-accordion').querySelector('.meganav-item-accordion-body');
                if (accordionBody != null) {
                  accordionBody.classList.toggle('open');
                }
              });
            });
          }

           this.$dropdowns.map(dropdown => {
             var dropdownParent = dropdown.closest("li");
             dropdownParent.addEventListener('mouseenter', function(ev) {
                dropdownParent.classList.add("dropdown-visible");
             });
             dropdownParent.addEventListener('mouseleave', function(ev) {
               dropdownParent.classList.remove("dropdown-visible");
             })
           });
                     	
        }

        reRender() {
            if(this.closest('modal-popup') && !this.modalInit) {
                this.modalInit = true;
                this.$dropdowns.map(dropdown => {
                    dropdown.addEventListener('click', (e) => {
                        e.preventDefault();
                        const dropId = e.currentTarget.dataset.dropdown;
                        const dropTarget = this.querySelector(`[data-dropby="${dropId}"]`);
                        dropTarget.classList.toggle('!active');
                    })
                })
            }
        }
    })
})();